import { LocalizedText, useFeatureFlag, useOpenAdaChat } from '@mews/framework';
import { FeatureFlag, TextKey } from '@mews-commander/enums';
import { Button } from '@optimus-web/core';

export const ContactUsButton = () => {
    const isAdaChatBotV2Enabled = useFeatureFlag(FeatureFlag.adaChatBotV2Enabled);
    const handleClick = useOpenAdaChat();

    if (!isAdaChatBotV2Enabled) {
        return null;
    }

    return (
        <Button onClick={handleClick} variant="primary" size="small" type="submit">
            <LocalizedText textKey={TextKey.ContactUs} />
        </Button>
    );
};
